export default "__VITE_PUBLIC_ASSET__887e4bc5__"